import NumericFormat from "react-number-format";
import { convertToJalali } from "../mini_components/ConvertToJalali";
import icons from "../lib/icons";

const StatementCard = ({ item }) => {
  const amountIsNegative = item.amount < 0;

  return (
    <div className="card-box-wrapper cursor-pointer " title="جزئیات" to={`#`}>
      {/* Top section: amount and date */}
      <div className="flex justify-between items-center w-full">
        <div className="flex items-center gap-1">
          <img
            src={
              item.type === "incomes"
                ? icons.pos_statements
                : icons.neg_statements
            }
            alt="Wallet"
            className="w-8 h-8"
          />
          <div className="flex items-center font-bold text-[16px] gap-1">
            <NumericFormat
              value={Math.abs(item.amount)}
              displayType="text"
              thousandSeparator
            />
            {amountIsNegative && <span>-</span>}
            <span className="text-neutral-60 text-sm">ریال</span>
          </div>
        </div>

        <p className="text-xs text-neutral-60" dir="ltr">
          {convertToJalali(item.created_at)}
        </p>
      </div>

      <div className="text-neutral-60 text-sm ">
        {item.type === "incomes" ? "درآمد" : "انتقال"}
      </div>

      {/* Balances section */}
      <div className="flex justify-between items-center  gap-1 md:gap-4 w-full mt-3">
        <BalanceBox
          label="موجودی قبلی:"
          amount={item.last_balance}
          color="text-gray-700"
        />

        <img src={icons.statements_arrow} alt="Transfer" className="w-6 h-6" />

        <BalanceBox
          label="موجودی جدید:"
          amount={item.new_balance}
          color="text-dark font-bold"
        />
      </div>
    </div>
  );
};

const BalanceBox = ({ label, amount, color }) => (
  <div className="bg-primary-40 flex-1 p-2 rounded-lg min-w-0">
    <p className="text-[12px] md:text-lg text-gray-500">{label}</p>
    <p

      className={`text-[12px] md:text-lg ${color} truncate overflow-hidden  text-center`}
      title={amount?.toLocaleString()}
    >
  <p className="text-primary-100" dir="ltr">    <NumericFormat value={amount} displayType="text" thousandSeparator /></p>
      <span className="text-neutral-60 text-[12px] md:text-lg mx-1">ریال</span>
    </p>
  </div>
);

export default StatementCard;
